import { render, staticRenderFns } from "./InfographicCard.vue?vue&type=template&id=2d5cf68e&scoped=true&"
import script from "./InfographicCard.vue?vue&type=script&lang=js&"
export * from "./InfographicCard.vue?vue&type=script&lang=js&"
import style0 from "./InfographicCard.vue?vue&type=style&index=0&id=2d5cf68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cf68e",
  null
  
)

export default component.exports